import { memo } from 'react';
import { CONTAINER_MISSING_NUMBER_MESSAGE } from 'lib/constants/subtasks';
import { Banner, Body, Title } from './styles';

interface IProps {
  title?: string;
  className?: string;
}

const ContainerMissingNumberWarning = ({
  title = 'Container Number required.',
  className,
}: IProps) => (
  <Banner role="alert" className={className}>
    <Title>{title}</Title>
    <Body>{CONTAINER_MISSING_NUMBER_MESSAGE}</Body>
  </Banner>
);

export default memo(ContainerMissingNumberWarning);
